module.exports = __webpack_public_path__ + "static/media/UKFlagIcon.05a65e15.svg";